
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bookingData: {
    CustomerName: '',
    CustomerType: '',
    EmailID: '',
    CheckIn: '',
    checkOUT: '',
    MobileNo: '',
    IdentityNo: '',
    IdentityType: '',
    CustomerAddress: '',
    hotelID: '',
    UserInfo: '',
    CustomerId: '',
    grandTotal: '',
    gst: '',
    totalPayable: '',
    tableData: '',
    TaxData: ''
  }
};

const bookingPreviewSlice = createSlice({
  name: 'bookingPreview',
  initialState,
  reducers: {
    setBookingData: (state, action) => {
      state.bookingData = action.payload;
    }
  }
});

export const { setBookingData } = bookingPreviewSlice.actions;
export default bookingPreviewSlice.reducer;